import { Store } from 'store/index';

const getCategoryById = (store: Store, categoryId: number) =>
  store.app.categories?.find((category) => category?.categoryId === categoryId);

export default getCategoryById;
